const re = new RegExp(/^[^ ]+@[^ ]+\.[^ ]+$/);
const validEmail = (email) => {
    if(!re.test(String(email)))
    {
        return("Enter valid email");
    }
}
export default validEmail;